import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class AirconunitService {
  getallAirconunit(data) {
    return axios.get(serverURL + "/airconunit-api?req=smarttableAirconunit", {
      params: data,
      headers: headeroption,
    })
  }
  getAirconunit(au_id) {
    return axios.get(serverURL + "/airconunit-api?req=getAirconunit", {
      params: { au_id: au_id }, headers: headeroption,
    });
  }
  createAirconunit(data) {
    return axios.post(serverURL + "/airconunit-api?req=createAirconunit", data, {
      headers: headeroption,
    });
  }
  updateAirconunit(data) {
    return axios.put(serverURL + "/airconunit-api?req=updateAirconunit", data, {
      headers: headeroption,
    });
  }
  deleteAirconunit(au_id) {
    return axios.delete(serverURL + "/airconunit-api?req=deleteAirconunit", { params: { au_id: au_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/airconunit-api?req=deleteAirconunit");
  }
  findByTitle(au_name) {
    return axios.get(serverURL + "/airconunit/airconunit-api?name=" + au_name);
  }
  upload(au_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?au_id=" + au_id, data, { headers: headeroptionupload });
  }
  uploads(au_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?au_id=" + au_id, data, { headers: headeroptionupload });
  }
}
export default new AirconunitService();
